import "../../external/preact/compat/dist/compat.module.js";
import { jsx as l } from "../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
const e = (r) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none", ...r, children: [
  /* @__PURE__ */ l("path", { d: "M8.7 7.3h2.9v1.4H8.7v2.9H7.3V8.7H4.4V7.3h2.9V4.4h1.4v2.9Z", fill: "currentColor" }),
  /* @__PURE__ */ l("path", { d: "M.3 8a7.7 7.7 0 1 1 15.4 0A7.7 7.7 0 0 1 .3 8ZM8 1.7a6.3 6.3 0 1 0 0 12.6A6.3 6.3 0 0 0 8 1.7Z", fill: "currentColor" })
] });
export {
  e as default
};
